import { api } from "@/lib/api";

const withTimeout = (p, ms) => Promise.race([p, new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms))]);
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const mixedContentBlocked = (url) => window.location.protocol === "https:" && url.startsWith("http:");

// Posts XML to a LAN printer from the device. Returns { ok, readable, text, reason }.
export async function postToPrinter(url, body, contentType = "text/xml", ms = 6000) {
  try {
    const r = await withTimeout(fetch(url, { method: "POST", headers: { "Content-Type": contentType }, body }), ms);
    const text = await r.text().catch(() => "");
    return { ok: r.ok && !/success="false"|ERR|error/i.test(text), readable: true, text };
  } catch (e) {
    try {
      await withTimeout(fetch(url, { method: "POST", mode: "no-cors", headers: { "Content-Type": contentType }, body }), ms);
      return { ok: true, readable: false, text: "" };
    } catch (e2) {
      return { ok: false, readable: false, reason: mixedContentBlocked(url) ? "mixed" : e2.message === "timeout" ? "timeout" : "unreachable" };
    }
  }
}

// Waits for the local print agent to complete a job (max ~12s).
async function waitJob(rid, jobId, agentOnline) {
  if (!agentOnline) return { ok: false, reason: "agent_offline", via: "agent" };
  for (let i = 0; i < 12; i++) {
    await sleep(1000);
    const { data } = await api.get(`/restaurants/${rid}/print-jobs/${jobId}`);
    if (data.status === "done") return { ok: true, via: "agent", text: data.result };
    if (data.status === "failed") return { ok: false, via: "agent", reason: "unreachable", text: data.result };
  }
  return { ok: false, via: "agent", reason: "agent_timeout" };
}

export async function probePrinter(rid, printer) {
  const { data } = await api.get(`/restaurants/${rid}/printers/${printer.id}/probe`);
  if (data.mode === "agent") {
    const res = await waitJob(rid, data.job_id, data.agent_online);
    const { data: saved } = await api.get(`/restaurants/${rid}/printers`).then((r) => ({ data: r.data.find((p) => p.id === printer.id) || printer }));
    return { ...res, printer: saved };
  }
  const res = await postToPrinter(data.url, data.body, data.content_type, 5000);
  const message = res.ok ? (res.readable ? "Risposta ricevuta dalla stampante" : "Raggiungibile (risposta non leggibile dal browser)") : res.reason;
  const { data: saved } = await api.post(`/restaurants/${rid}/printers/${printer.id}/status`, { online: res.ok, message });
  return { ...res, printer: saved };
}

export async function printReceipt(rid, receipt, printerId) {
  let payload;
  try { payload = (await api.post(`/restaurants/${rid}/receipts/${receipt.id}/print`, null, { params: printerId ? { printer_id: printerId } : {} })).data; } catch { return null; }
  if (payload.mode === "agent") return { ...(await waitJob(rid, payload.job_id, payload.agent_online)), printer: payload.printer };
  const res = await postToPrinter(payload.url, payload.body, payload.content_type);
  api.post(`/restaurants/${rid}/receipts/${receipt.id}/printed`, { ok: res.ok, printer_name: payload.printer.name }).catch(() => {});
  return { ...res, printer: payload.printer };
}
